// @ts-nocheck

import React from 'react';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';

import styled from 'styled-components';

import { Section } from './../../../components/layout';
import Grid, { GridItem } from './../../../components/layout/Grid';

import Form from '../../../components/Form';
import CancelButton from '../../../components/CancelButton';

import {
  fuelAndOilGroup,
  fuelAndOilSubType,
  fuelAndOilSubView,
  fuelAndOilType,
  fuelAndOilView } from
'../../../lib/enum';








import { Option, Select } from './../../../components/ant/Select';

const Content = styled.div.withConfig({ displayName: "InnerForm__Content", componentId: "sc-1sqv9dt-0" })(["padding:16px;"]);



const Footer = styled(Section).withConfig({ displayName: "InnerForm__Footer", componentId: "sc-1sqv9dt-1" })(["padding:16px;display:flex;justify-content:space-between;align-items:center;"]);
















export default ({
  fuelAndOil,
  onSubmit,
  onCancel,
  getSubViews,
  getTypes,
  getSubTypes,
  getGroups
}) =>
<Form initialValues={fuelAndOil} onSubmit={onSubmit}>
    {(FormField, formikProps) => {
    const { handleSubmit, dirty, isSubmitting, setFieldValue, values } =
    formikProps;
    const subViews = getSubViews(values);
    const types = getTypes(values);
    const subTypes = getSubTypes(values);
    const groups = getGroups(values);
    return (
      <form onSubmit={handleSubmit}>
          <Section>
            <Content>
              <Grid gutter="16px">
                <GridItem>
                  <FormField label="Наименование" required name="name">
                    {(field) => <Input {...field} />}
                  </FormField>
                </GridItem>
                <GridItem>
                  <FormField label="Вязкость" required name="viscosity">
                    {(field) => <Input {...field} />}
                  </FormField>
                </GridItem>

                <GridItem>
                  <FormField label="Вид" required name="view">
                    {({ name, value }) =>
                  <Select
                    placeholder="Выберите вид ГСМ"
                    value={value}
                    onChange={(view) => {
                      setFieldValue(name, view);
                      setFieldValue('subView', null);
                      setFieldValue('type', null);
                      setFieldValue('subType', null);
                      setFieldValue('group', null);
                    }}
                    data-cy="viewSelect">

                        {Object.keys(fuelAndOilView).map(
                      (view) =>
                      <Option key={view} value={view}>
                              {fuelAndOilView[view]}
                            </Option>

                    )}
                      </Select>
                  }
                  </FormField>
                </GridItem>

                {subViews && subViews.length > 0 &&
              <GridItem>
                    <FormField label="Подвид" required name="subView">
                      {({ name, value }) =>
                  <Select
                    placeholder="Выберите подвид ГСМ"
                    value={value}
                    onChange={(subView) => {
                      setFieldValue(name, subView);
                      setFieldValue('type', null);
                      setFieldValue('subType', null);
                      setFieldValue('group', null);
                    }}
                    data-cy="subViewSelect">

                          {subViews.map((subView) =>
                    <Option key={subView} value={subView}>
                              {fuelAndOilSubView[subView]}
                            </Option>
                    )}
                        </Select>
                  }
                    </FormField>
                  </GridItem>
              }

                {types && types.length > 0 &&
              <GridItem>
                    <FormField label="Тип" required name="type">
                      {({ name, value }) =>
                  <Select
                    placeholder="Выберите тип ГСМ"
                    value={value}
                    onChange={(type) => {
                      setFieldValue(name, type);
                      setFieldValue('subType', null);
                      setFieldValue('group', null);
                    }}>

                          {types.map((type) =>
                    <Option key={type} value={type}>
                              {fuelAndOilType[type]}
                            </Option>
                    )}
                        </Select>
                  }
                    </FormField>
                  </GridItem>
              }

                {subTypes && subTypes.length > 0 &&
              <GridItem>
                    <FormField label="Подтип" required name="subType">
                      {({ name, value }) =>
                  <Select
                    placeholder="Выберите подтип ГСМ"
                    value={value}
                    onChange={(subType) => {
                      setFieldValue(name, subType);
                      setFieldValue('group', null);
                    }}>

                          {subTypes.map((subType) =>
                    <Option key={subType} value={subType}>
                              {fuelAndOilSubType[subType]}
                            </Option>
                    )}
                        </Select>
                  }
                    </FormField>
                  </GridItem>
              }

                {groups && groups.length > 0 &&
              <GridItem>
                    <FormField label="Группа" required name="group">
                      {({ name, value }) =>
                  <Select
                    placeholder="Выберите группу ГСМ"
                    value={value}
                    onChange={(group) => {
                      setFieldValue(name, group);
                    }}>

                          {groups.map((group) =>
                    <Option key={group} value={group}>
                              {fuelAndOilGroup[group]}
                            </Option>
                    )}
                        </Select>
                  }
                    </FormField>
                  </GridItem>
              }
              </Grid>
            </Content>
          </Section>
          <Footer>
            <Button
            disabled={isSubmitting}
            loading={isSubmitting}
            type="primary"
            data-cy="save"
            htmlType="submit"
            className="login-form-button">

              Сохранить
            </Button>
            <CancelButton dirty={dirty} onClick={onCancel}>
              Отменить
            </CancelButton>
          </Footer>
        </form>);

  }}
  </Form>;
